<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left class="corp-actions-title">
    <h2 class="title">Rule Overview</h2>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right class="popoverBtn">
    <button
      #searchRulePopoverComponent="ngbPopover"
      nf-button="primary"
      ngbTooltip="Search for Rules"
      placement="auto"
      [ngbPopover]="popoverContent"
      autoClose="outside"
      container="body"
      popoverClass="find-rules-popover"
      (shown)="onSearchPopoverShown()"
      (hidden)="onSearchPopoverHidden()"
    >
      Find Rules
    </button>
    <ng-template #popoverContent>
      <ng-content></ng-content>
    </ng-template>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <span>
      <nf-table-layout
        [hideTitle]="true"
        [gridOptions]="gridOptions"
        [autoResizeGrid]="false"
        [data]="rowRulesData"
        hideSearch
        hideClearAll
        *nfLoader="isRuleLoading"
      >
      </nf-table-layout>
    </span>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
